import { render, staticRenderFns } from "./PainelTransicaoGestao.vue?vue&type=template&id=477d7f19"
import script from "./PainelTransicaoGestao.vue?vue&type=script&lang=js"
export * from "./PainelTransicaoGestao.vue?vue&type=script&lang=js"
import style0 from "./PainelTransicaoGestao.vue?vue&type=style&index=0&id=477d7f19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports